import React, { Component } from "react";
import helpers from "../../helpers";

const cards = require.context("../../assets/img/payment/light", true);

const currency_symbols = {
  USD: "$", // US Dollar
  ILS: "₪", // Israeli New Sheqel
};

export default class ReloadBalance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      user: props.user,
      computerUserRef: props.computerUserRef,
      complete: false,
      loading: false,
      error: null,
      loadingNewCard: false,
    };
    this.card = React.createRef();
    this.paymentMessageListener = this.paymentMessageListener.bind(this);
  }

  /** Ignore unrelated window.postMessage traffic (PDF workers, WebViews, extensions, etc.). */
  isTranzilaPaymentPostMessage(data, origin) {
    if (data == null || typeof data !== "object" || Array.isArray(data)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(data, "Response")) {
      return false;
    }
    try {
      const { hostname } = new URL(origin);
      return (
        hostname === "direct.tranzila.com" || hostname.endsWith(".tranzila.com")
      );
    } catch (e) {
      return false;
    }
  }

  paymentMessageListener(event) {
    const { data, origin } = event;
    if (!this.isTranzilaPaymentPostMessage(data, origin)) {
      return;
    }

    const { Response, error } = data;
    if (Response !== "000") {
      const $appError = $("#app-error");
      $appError
        .text(error || "Payment could not be completed")
        .addClass("snackbar-active");
      setTimeout(() => $appError.removeClass("snackbar-active"), 5000);
    } else {
      this.setState({ loadingNewCard: true });

      // todo: make sure the form of card is gone
      this.state.app.state.userRef.update({
        payment: {
          token: data.TranzilaTK,
          details: {
            brand: "unknown",
            exp_month: data.expmonth,
            exp_year: data.expyear,
            type: data.cred_type,
            last4: data.TranzilaTK.slice(-4),
          },
        },
      });

      setTimeout(() => {
        this.setState({ loadingNewCard: false });
      }, 5000);
    }
  }

  componentDidMount() {
    this.setState({
      paymentUrl: `https://direct.tranzila.com/nadav2002/iframe.php?template=custom&sum=0.1&client=${this.state.user.uid}`,
    });

    window.addEventListener("message", this.paymentMessageListener);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.paymentMessageListener);
  }

  render() {
    const client = this.state.app.state.client;

    let card, cardPreview, amount, currency;

    if (!client || !client.balance || !client.balance.amount) {
      amount = 0;
      currency = "ILS";
    } else {
      amount = Number(client.balance.amount).toFixed(2);
      currency = client.balance.currency;
    }

    try {
      card = client.payment.details;
    } catch (e) {}

    if (card) {
      switch (card.brand.toLowerCase()) {
        case "diners club":
          card.img = cards("./diners-club.png");
          break;
        case "discover":
          card.img = cards("./discover.png");
          break;
        case "mastercard":
          card.img = cards("./mastercard.png");
          break;
        case "visa":
          card.img = cards("./visa.png");
          break;
        case "american express":
          card.img = cards("./american-express.png");
          break;
        case "isracard":
          card.img = cards("./isracard.png");
          break;
      }
      cardPreview = (
        <div className="card-preview" style={{ display: "block" }}>
          <div
            style={{ display: "flex", justifyContent: "center" }}
            // onClick={() => this.state.app.change("wallet")}
          >
            <img src={card.img} />
            <span className="details">
              {card.brand} {card.last4}
            </span>
          </div>
          <div
            className="divider"
            style={{ marginBottom: "10px", marginTop: "10px" }}
          ></div>
          <a
            href="#"
            onClick={() => this.state.app.change("wallet")}
            style={{ fontSize: "16px" }}
          >
            <i className="fad fa-wallet" style={{ paddingRight: "5px" }}></i>
            <span>Change card</span>
          </a>
        </div>
      );
    } else {
      cardPreview = (
        <div
          className="center-text-huge top-10 bottom-0"
          style={{ background: "#efefef" }}
        >
          <iframe
            src={this.state.paymentUrl}
            scrolling="no"
            style={{
              width: 100 + "%",
              height: 157 + "px",
              border: "1px solid #e5e5e5",
              borderBottom: 0,
              borderRight: 0,
              borderLeft: 0,
            }}
          />
        </div>
      );
    }

    const requiredBalance = this.props.printCost > 10 ? this.props.printCost : 10;
    const chargeAmount = Number((requiredBalance - (client && client.balance ? client.balance.amount : 0)).toFixed(2));

    let textButton = this.state.loading ? (
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    ) : (
      `Add ₪${chargeAmount}`
    );

    const charge = async () => {
      this.setState({ loading: true });
      const { details, token } = client.payment;
      const { exp_month, exp_year, type } = details;
      const response = await helpers.serviceRequest("chargeClient", {
        accountId: this.state.computerUserRef.id,
        clientId: this.state.user.uid,
        payment: {
          details: { exp_month, exp_year, type },
          token,
        },
        amount: chargeAmount,
        currency: "ILS",
      });
      const { Response, error } = response;
      if (Response !== "000") {
        const $appError = $("#app-error");
        $appError
          .text(error || "The card was declined. Please try again")
          .addClass("snackbar-active");
        setTimeout(() => $appError.removeClass("snackbar-active"), 5000);
      }
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1500);
    };

    return (
      <div
        id="reload-balance"
        className="menu menu-box-bottom full-center"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        {this.state.loadingNewCard ? (<div>
        <div className="bottom-10 top-20">
          <h2 className="capitalize bold">Top Up Balance</h2>
          <div
            className="center-text-huge top-5 bottom-5 font-18"
            // style={{ direction: "rtl" }}
          >
            <div style={{ display: "inline-block" }}>Account balance: </div>{" "}
            <div
              style={{
                display: "inline-block",
                direction: "ltr",
                color: chargeAmount > 10 ? "#0080a2" : "#006400",
              }}
            >
              {`${currency_symbols[currency.toUpperCase()]}${amount}`}
            </div>
          </div>
        </div>
          <a
            href="#"
            className="button button-s button-center-large button-round-medium shadow-large bg-highlight"
            // style={{ direction: "rtl" }}
            onClick={charge}
          >
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </a>
        </div>) : (<div>
        <div className="bottom-10 top-20">
          <h2 className="capitalize bold">Top Up Balance</h2>
          <div
            className="center-text-huge top-5 bottom-5 font-18"
            // style={{ direction: "rtl" }}
          >
            <div style={{ display: "inline-block" }}>Account balance: </div>{" "}
            <div
              style={{
                display: "inline-block",
                direction: "ltr",
                color: chargeAmount > 10 ? "#0080a2" : "#006400",
              }}
            >
              {`${currency_symbols[currency.toUpperCase()]}${amount}`}
            </div>
          </div>
          {this.props.printCost && <div
            className="center-text-huge top-5 bottom-5 font-18"
            // style={{ direction: "rtl" }}
          >
            <div style={{ display: "inline-block" }}>Print cost: </div>{" "}
            <div
              style={{
                display: "inline-block",
                direction: "ltr",
                color: "#ed143d",
              }}
            >
              {`${currency_symbols[currency.toUpperCase()]}${this.props.printCost.toFixed(2)}`}
            </div>
          </div>}
          {cardPreview}
        </div>
        {client && client.payment && client.payment.token ? (
          <a
            href="#"
            className="button button-s button-center-large button-round-medium shadow-large bg-highlight"
            // style={{ direction: "rtl" }}
            onClick={charge}
          >
            {textButton}
          </a>
        ) : null}
        </div>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/menus/ReloadBalance.js